import { styled } from '@mui/material'
import { rgba } from 'polished'

import { statusChipBase } from 'components/Status/Status.styles'

import logError from 'utils/errorLogger'

import { theme } from 'styles/theme'

export const getStyle = (status: string) => {
  switch (status) {
    case 'pending':
      return {
        label: 'Pendente',
        background: rgba(theme.palette.neutral[700], 0.3),
        color: theme.palette.neutral[400]
      }
    case 'issued':
      return {
        label: 'Programada',
        background: rgba(theme.palette.alert[300], 0.3),
        color: theme.palette.alert[300]
      }
    case 'confirmed':
      return {
        label: 'Emitida',
        background: rgba(theme.palette.primary[300], 0.3),
        color: theme.palette.primary[300]
      }
    case 'canceled':
      return {
        label: 'Cancelada',
        background: rgba(theme.palette.error[300], 0.3),
        color: theme.palette.error[300]
      }
    case 'failed':
      return {
        label: 'Falhada',
        background: rgba(theme.palette.error[300], 0.3),
        color: theme.palette.error[300]
      }
    default:
      logError(`Erro ao mapear status da Invoice details: ${status}`)

      return {
        label: 'Status desconhecido',
        background: rgba(theme.palette.neutral[700], 0.3),
        color: theme.palette.neutral[400]
      }
  }
}

export const ContainerIcon = styled('div')(() => ({
  width: '35px',
  height: '35px',
  background: theme.palette.neutral[800],
  borderRadius: '8px',

  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
}))

export const Wrapper = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '22px'
}))

export const WrapperContent = styled('div')(() => ({
  display: 'flex',
  border: `1px solid ${theme.palette.neutral[700]}`,
  borderRadius: '8px',
  padding: '16px',
  boxSizing: 'border-box',
  backgroundColor: theme.palette.neutral.A200
}))

export const Separator = styled('div')(() => ({
  width: '1fr',
  flexGrow: '1',
  borderTop: '0.5px dashed #CBCBCB',
  alignSelf: 'center',
  marginTop: '2px'
}))

type StatusProps = {
  status: string
}

export const Status = styled('div')<StatusProps>(({ status }) => ({
  ...statusChipBase,
  ...getStyle(status)
}))

export const BillingsSection = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
  marginTop: '8px'
}))

export const BillingCard = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  padding: '12px',
  border: `1px solid ${theme.palette.neutral[700]}`,
  borderRadius: '8px',
  backgroundColor: theme.palette.neutral.A100,
  cursor: 'pointer',
  transition: 'border-color 180ms ease-out, background-color 180ms ease-out',
  '&:hover': {
    borderColor: theme.palette.neutral[600],
    backgroundColor: theme.palette.neutral[900]
  }
}))

export const BillingHeader = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: '8px'
}))

export const BillingInfo = styled('div')(() => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: '16px'
}))
